import template from './tasks-edit.html'
export default {
	controller,
	controllerAs: 'vm',
	template,
}

/* @ngInject */
function controller($mdDialog, $log, Task, task) {
	var vm = this
	vm.$onInit = () => {
		//API methods
		vm.cancel = cancel
		vm.update = update

		//Scope attributes
		vm.statusOptions = Task.meta.statusLabels
		vm.task = task.cloneFields()

		activate()
		function activate() {}

		function cancel() {
			close()
		}

		function close() {
			$mdDialog.cancel()
		}

		function update() {
			task.DSUpdate(vm.task).then(
				function (task) {
					close()
				},
				function (err) {
					$log.warn(err)
				},
			)
		}
	}
}
